import { render, staticRenderFns } from "./VersionSelectorBadges.vue?vue&type=template&id=6ce0dc97&"
import script from "./VersionSelectorBadges.vue?vue&type=script&lang=js&"
export * from "./VersionSelectorBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports